/* @pareto-engineering/generator-front 1.0.12 */
import { urljoin as _u } from 'utils'

export const opsBasePath = '/outsourced-ops-solutions'
export const basePath = '/'

const slugUrlParam = ':slug([0-9a-z-]{3,80})?'

export default {
  OPS_LIST       :_u(opsBasePath),
  OPS_SINGLE     :_u(opsBasePath, slugUrlParam),
  USE_CASE_SINGLE:_u(basePath, slugUrlParam),
}
